import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Search20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 1.75C6.99594 1.75 3.75 4.99594 3.75 9C3.75 10.7319 4.35728 12.322 5.37051 13.5689L1.46973 17.4697L2.53039 18.5303L6.43117 14.6295C7.67808 15.6427 9.26812 16.25 11 16.25C15.0041 16.25 18.25 13.0041 18.25 9C18.25 4.99594 15.0041 1.75 11 1.75ZM5.25 9C5.25 5.82436 7.82436 3.25 11 3.25C14.1756 3.25 16.75 5.82436 16.75 9C16.75 12.1756 14.1756 14.75 11 14.75C7.82436 14.75 5.25 12.1756 5.25 9Z'
      fill='currentColor'
    />
  </Svg>
);

Search20.displayName = 'Search20';
export default Search20;
